import { createAction, props } from '@ngrx/store';
import { Pagination } from '@shared/models/pagination.model';

import { StockListNegativeCount, StockListPagination, StockListSearchCriteria } from '../models/stock-list.model';
import {
  AdjustTransaction,
  StockInfoBarcode,
  StockMovementList,
  StockMovementListSearchCriteria,
  StockView
} from '../models/stock-view.model';

export const StockAction = {
  stockListRequest: createAction('[Stock] stock list request', props<{ payload: StockListSearchCriteria }>()),
  stockListResponse: createAction('[Stock] stock list response', props<{ response: StockListPagination }>()),
  stockListNativeCountRequest: createAction('[Stock] stock list native count request'),
  stockListNativeCountResponse: createAction(
    '[Stock] stock list native count response',
    props<{ response: StockListNegativeCount }>()
  ),
  stockSummaryRequest: createAction('[Stock] stock summary request', props<{ articleNo: string }>()),
  stockSummaryResponse: createAction('[Stock] stock summary response', props<{ response: StockView }>()),
  stockMovementListRequest: createAction(
    '[Stock] stock movement list request',
    props<{ payload: StockMovementListSearchCriteria }>()
  ),
  stockMovementListResponse: createAction(
    '[Stock] stock movement list response',
    props<{ response: Pagination<StockMovementList> }>()
  ),
  stockBarcodeListRequest: createAction('[Stock] stock barcode request', props<{ articleNo: string }>()),
  stockBarcodeListResponse: createAction('[Stock] stock barcode response', props<{ response: StockInfoBarcode[] }>()),
  adjustTransactionRequest: createAction('[Stock] adjust transaction request', props<{ articleNo: string }>()),
  adjustTransactionResponse: createAction(
    '[Stock] adjust transaction response',
    props<{
      response: AdjustTransaction[];
    }>()
  )
};
